import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch, PrivateRoute } from 'components/route'
import { useRouter } from 'hooks/useRouter'
import React from 'react'
import Permissions from 'types/Permissions'
import AgendamentoEsusView from 'view/agenda/AgendamentoEsusView'
import AtendimentoEsusView from 'view/atendimentos/esus/AtendimentoEsusView'

import { CidadaoCreateView } from './create/CidadaoCreateView'
import { CidadaoEditView } from './create/CidadaoEditView'
import { CidadaoListView } from './list/CidadaoListView'
import { CidadaoDadosView } from './visualizacao/CidadaoDadosView'

export function CidadaoRootView() {
  const { match } = useRouter()

  return (
    <>
      <Breadcrumb title='Cidadão' />

      <PecSwitch>
        <PrivateRoute
          path={`${match.url}/visualizarProntuario`}
          component={AtendimentoEsusView}
          permission={Permissions.visualizarProntuario}
        />
        <PrivateRoute
          path={`${match.url}/visualizarAgendamento`}
          component={AgendamentoEsusView}
          permission={Permissions.visualizarAgenda}
        />

        <PrivateRoute
          path={`${match.url}/create`}
          component={CidadaoCreateView}
          permission={Permissions.gestaoDeCadastrosDeCidadao.visualizarCidadao.cadastrarEEditar}
        />

        <PrivateRoute
          exact
          path={`${match.url}/:cidadaoId(\\d+)/edit`}
          component={CidadaoEditView}
          permission={Permissions.gestaoDeCadastrosDeCidadao.visualizarCidadao.cadastrarEEditar}
        />
        <PrivateRoute
          exact
          path={`${match.url}`}
          component={CidadaoListView}
          permission={Permissions.gestaoDeCadastrosDeCidadao.visualizarCidadao}
        />
        <PrivateRoute
          path={`${match.url}/:cidadaoId(\\d+)`}
          component={CidadaoDadosView}
          permission={Permissions.gestaoDeCadastrosDeCidadao.visualizarCidadao}
        />
      </PecSwitch>
    </>
  )
}
